import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { onDestroy } from 'svelte';
import { getLanguage, subscribeLanguageChange, t } from '../i18n.ts';
import Button from './svelte-button.svelte';
import DropdownMenu from './svelte-dropdown-menu.svelte';

var root = $.from_html(`<span class="ui-symbol-kebab">...</span>`);
var root_1 = $.from_html(`<button type="button" class="ui-menu-item" role="menuitem"> </button> <button type="button" class="ui-menu-item" role="menuitem"> </button> <button type="button" class="ui-menu-item" role="menuitem"> </button>`, 1);
var root_2 = $.from_html(`<div class="section-label"> </div> <div class="preview-shape-group svelte-zvvfov"></div> <!>`, 1);

const $$css = {
	hash: 'svelte-zvvfov',
	code: '.preview-shape-group.svelte-zvvfov {display:flex;align-items:center;gap:8px;flex-wrap:wrap;justify-content:flex-start;}\n  @media (max-width: 900px) {.preview-shape-group.svelte-zvvfov {width:100%;justify-content:flex-start;}\n  }'
};

export default function Svelte_preview_shape_bar($$anchor, $$props) {
	$.push($$props, true);
	$.append_styles($$anchor, $$css);

	const PREVIEW_SHAPES = [
		{ key: 'sphere', label: 'Sphere' },
		{ key: 'cube', label: 'Cube' },
		{ key: 'torus', label: 'Torus' }
	];

	let activeShape = $.prop($$props, 'activeShape', 7, 'sphere'),
		wireframeEnabled = $.prop($$props, 'wireframeEnabled', 7, false);

	function dispatch(eventName, detail) {
		$$props.$$host.dispatchEvent(new CustomEvent(eventName, { detail, bubbles: true, composed: true }));
	}

	let language = $.state($.proxy(getLanguage()));

	const disposeLanguageSync = subscribeLanguageChange((nextLanguage) => {
		$.set(language, nextLanguage, true);
	});

	function tr(key, values) {
		$.get(language);

		return values ? t(key, values) : t(key);
	}

	const wireframeLabel = $.derived(() => tr('preview.menuWireframeToggle', {
		state: wireframeEnabled() ? tr('common.on') : tr('common.off')
	}));

	function isValidPreviewShapeType(value) {
		return value === 'sphere' || value === 'cube' || value === 'torus';
	}

	function handleSelectShape(nextShape) {
		if (!isValidPreviewShapeType(nextShape)) {
			dispatch('status-message', {
				message: t('preview.status.invalidSelectedShape', { value: String(nextShape) }),
				kind: 'error'
			});

			return;
		}

		if (nextShape === activeShape()) {
			return;
		}

		activeShape(nextShape);
		dispatch('preview-shape-change', { shape: nextShape });
	}

	function handleSelectActionMenu(action) {
		if (action === 'toggle-wireframe') {
			const next = !wireframeEnabled();

			wireframeEnabled(next);
			dispatch('preview-wireframe-change', { enabled: next });

			return;
		}

		if (action === 'export-main-preview') {
			dispatch('export-main-preview-png');

			return;
		}

		dispatch('export-step-preview-png');
	}

	onDestroy(() => {
		disposeLanguageSync();
	});

	var $$exports = {
		get activeShape() {
			return activeShape();
		},

		set activeShape($$value = 'sphere') {
			activeShape($$value);
			$.flush();
		},

		get wireframeEnabled() {
			return wireframeEnabled();
		},

		set wireframeEnabled($$value = false) {
			wireframeEnabled($$value);
			$.flush();
		}
	};

	var fragment = $.comment();
	var node = $.first_child(fragment);

	$.key(node, () => $.get(language), ($$anchor) => {
		var fragment_1 = root_2();
		var div = $.first_child(fragment_1);
		var text = $.only_child(div, true);
		var div_1 = $.sibling(div, 2);

		$.each(div_1, 21, () => PREVIEW_SHAPES, (shape) => shape.key, ($$anchor, shape) => {
			{
				let $0 = $.derived(() => activeShape() === $.get(shape).key);

				Button($$anchor, {
					type: 'button',
					get active() {
						return $.get($0);
					},
					handlePress: () => handleSelectShape($.get(shape).key),
					children: ($$anchor, $$slotProps) => {
						$.next();

						var text_1 = $.text();

						$.template_effect(() => $.set_text(text_1, $.get(shape).label));
						$.append($$anchor, text_1);
					},
					$$slots: { default: true }
				});
			}
		});

		$.reset(div_1);

		var node_1 = $.sibling(div_1, 2);

		{
			const trigger = ($$anchor) => {
				var span = root();

				$.append($$anchor, span);
			};

			const children = ($$anchor, closeMenu = $.noop) => {
				var fragment_4 = root_1();
				var button = $.first_child(fragment_4);
				var text_2 = $.only_child(button, true);
				var button_1 = $.sibling(button, 2);
				var text_3 = $.only_child(button_1, true);
				var button_2 = $.sibling(button_1, 2);
				var text_4 = $.only_child(button_2, true);

				$.template_effect(
					($0, $1) => {
						$.set_text(text_2, $.get(wireframeLabel));
						$.set_text(text_3, $0);
						$.set_text(text_4, $1);
					},
					[
						() => tr('preview.menuExportMainPng'),
						() => tr('preview.menuExportStepPng')
					]
				);

				$.delegated('click', button, () => {
					closeMenu()();
					void handleSelectActionMenu('toggle-wireframe');
				});

				$.delegated('click', button_1, () => {
					closeMenu()();
					void handleSelectActionMenu('export-main-preview');
				});

				$.delegated('click', button_2, () => {
					closeMenu()();
					void handleSelectActionMenu('export-step-preview');
				});

				$.append($$anchor, fragment_4);
			};

			let $0 = $.derived(() => tr('preview.menuButtonAria'));

			DropdownMenu(node_1, {
				wrapperClass: 'ui-menu-wrap preview-action-menu-wrap',
				menuClass: 'ui-menu preview-kebab-menu',
				get triggerAriaLabel() {
					return $.get($0);
				},
				menuRole: 'menu',
				triggerVariant: 'menu-trigger',
				trigger,
				children,
				$$slots: { trigger: true, default: true }
			});
		}

		$.template_effect(($0) => $.set_text(text, $0), [() => tr('preview.shapeLabel')]);
		$.append($$anchor, fragment_1);
	});

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

$.delegate(['click']);
customElements.define('lut-preview-shape-bar', $.create_custom_element(Svelte_preview_shape_bar, { activeShape: {}, wireframeEnabled: {} }, [], []));